import { SaveOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, Select, Space } from 'antd';

const ROLE_OPTIONS = [
  { label: 'Administrator', value: 'administrator' },
  { label: 'Standard', value: 'user' },
];

const EditUserModal = ({ open, onCancel, onSubmit, loading, form }) => {
  return (
    <Modal title="Edit User" open={open} onCancel={onCancel} footer={null} width={500}>
      <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Form.Item
          label="First Name"
          name="firstName"
          rules={[{ required: true, message: 'First Name is required' }]}
        >
          <Input placeholder="First Name" />
        </Form.Item>
        <Form.Item
          label="Last Name"
          name="lastName"
          rules={[{ required: true, message: 'Last Name is required' }]}
        >
          <Input placeholder="Last Name" />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: 'Email is required' },
            { type: 'email', message: 'Invalid email format' },
          ]}
        >
          <Input placeholder="Email" />
        </Form.Item>
        <Form.Item
          label="Role"
          name="role"
          rules={[{ required: true, message: 'Role is required' }]}
        >
          <Select placeholder="Select Role" options={ROLE_OPTIONS} />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          <Space>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={loading}>
              Save Changes
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditUserModal;
